import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class PanelHeader extends PureComponent {
  render() {
    const { children, className, access, ...others } = this.props;
    const cls = classNames({
      "weui-panel__hd": true
    }, className);

    return (
      <div className={ cls } { ...others }>{ children }</div>
    );
  }
}
